import { configureStore } from '@reduxjs/toolkit';
import searchFiltersReducer from './slices/searchFiltersSlice';

export const store = configureStore({
  reducer: {
    searchFilters: searchFiltersReducer,
  },
});


export default store;
